import { Stack, Typography } from "@mui/material";

import ImageGeneralError from "../assets/images/general-error@2x.png";

interface CardContentErrorProps {
  size?: 'small' | 'large';
  message: string;
  details?: string;
}

export const CardContentError = ({
  size = 'large',
  message,
  details,
  ...props
}: CardContentErrorProps) => {
  const imageWidth = size === 'small' ? 218 : 437;

  return (
    <Stack 
      spacing={2}
      padding={4}
      className="cp-resp-sign-card d-flex-column-center">
      <img src={ImageGeneralError} alt="image_general_error" width={imageWidth}/>

      <Stack alignContent="center">
        <Typography className="cp-hint" textAlign="center">
          {message}
        </Typography>

        {details && details.length > 1 && (
          <>
            <Typography className="cp-hint" sx={{ fontWeight: 'bold' }}>
              Error Details:
            </Typography>

            <Typography className="cp-hint">
              {details}
            </Typography>
          </>
        )}
      </Stack>
    </Stack>
  );
};
